import { convertAmount, getAmountWithCurrency } from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';

export const WinPopUp = ({ winAmount, t }) => {
  return (
    <div className='win-pop-wrapper'>
      <div className='win-popup'>
        <p className='win-text'>{t(globalTranslationKeys.YouWin)}</p>
        <p className='win-price-n'>
          {getAmountWithCurrency({
            amount: convertAmount(winAmount),
            withSpace: true,
          })}
        </p>
      </div>
    </div>
  );
};
